/* eslint-disable */
import * as registry from '../registry.js'
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Season_Mid_Season_Text1Inputs */



/**
* | countPlural | output |
* | --- | --- |
* | "one" | "The boiler room switches to summer or winter mode depending on the outdoor temperature" |
* | "other" | "The boilers switch to summer or winter mode depending on the outdoor temperature" |
*
* @param {Season_Mid_Season_Text1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const season_mid_season_text1 = /** @type {((inputs: Season_Mid_Season_Text1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Season_Mid_Season_Text1Inputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") {
		const countPlural = registry.plural("en", i?.count, {}, true);
		if (countPlural === "one") return /** @type {LocalizedString} */ (`The boiler room switches to summer or winter mode depending on the outdoor temperature`);
		if (countPlural === "other") return /** @type {LocalizedString} */ (`The boilers switch to summer or winter mode depending on the outdoor temperature`);
		return /** @type {LocalizedString} */ ("season_mid_season_text1");
	}
	{
		const countPlural = registry.plural("fr", i?.count, {}, true);
		if (countPlural === "one") return /** @type {LocalizedString} */ (`La chaufferie passe en fonctionnement été ou hiver selon la température extérieure`);
		if (countPlural === "other") return /** @type {LocalizedString} */ (`Les chaufferies passent en fonctionnement été ou hiver selon la température extérieure`);
		return /** @type {LocalizedString} */ ("season_mid_season_text1");
	}
});